import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/bg-financial-tips-desktop.jpg'


const _withScopeId = n => (_pushScopeId("data-v-42cb9158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "obligation-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary text-base" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Consejos financieros ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "text-gris80 text-xs" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "flex bg-white rounded-lg shadow-lg p-5 overflow-y-auto" }
const _hoisted_7 = { class: "w-2/3" }
const _hoisted_8 = { class: "text-left text-base font-normal italic text-gris80 inline" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1/3 text-right" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-3/6 inline",
    src: _imports_0,
    alt: "tips financieros icono"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("span", _hoisted_4, " Última actualización: " + _toDisplayString(_ctx.timestamp), 1),
    _hoisted_5,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTips, (tip, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "mt-5 mb-5"
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(tip), 1)
          ]),
          _hoisted_9
        ])
      ]))
    }), 128))
  ]))
}